function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "mastercard-color_large"
}, /*#__PURE__*/React.createElement("rect", {
  id: "card_bg",
  width: 48,
  height: 32,
  rx: 4,
  fill: "white"
}), /*#__PURE__*/React.createElement("g", {
  id: "mastercard"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  opacity: 0.01
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 4.65039,
  y: 3.19995,
  width: 38.71,
  height: 25.6,
  fill: "white"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2",
  x: 18.9004,
  y: 7.65991,
  width: 10.21,
  height: 16.68,
  fill: "#F26122"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M20.0007 15.9999C19.9839 12.7535 21.4584 9.67899 24.0007 7.65994C19.651 4.23923 13.4027 4.73596 9.64802 8.80094C5.89337 12.8659 5.89337 19.1339 9.64802 23.1989C13.4027 27.2639 19.651 27.7606 24.0007 24.3399C21.4584 22.3209 19.9839 19.2464 20.0007 15.9999Z",
  fill: "#EA1D25"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.1395 22.2299V22.5699H40.0795V22.2299H39.9395V22.1599H40.2895V22.2299H40.1395ZM40.8195 22.1599V22.5699H40.7495V22.2599L40.6395 22.5299H40.5595L40.4395 22.2599V22.5699H40.3695V22.1599H40.4695L40.5995 22.4499L40.7195 22.1599H40.8195Z",
  fill: "#F69E1E"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  d: "M41.16 16C41.1574 20.0593 38.8389 23.7614 35.1879 25.5358C31.5369 27.3102 27.1935 26.846 24 24.34C28.6001 20.7179 29.3967 14.0543 25.78 9.44999C25.2616 8.78326 24.6638 8.18216 24 7.65999C27.1935 5.15398 31.5369 4.68973 35.1879 6.46416C38.8389 8.23859 41.1574 11.9406 41.16 16Z",
  fill: "#F69E1E"
})));

var SvgMastercard = function SvgMastercard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMastercard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mastercard.eac82db1.svg";
export { ForwardRef as ReactComponent };